import React, { useState } from 'react';
import icArrowEmpty1 from 'Assets/img/sidebar/ic_arrow_666_14.png';
import icArrowEmpty2 from 'Assets/img/sidebar/ic_arrow_666_14@2x.png';
import icArrowEmpty3 from 'Assets/img/sidebar/ic_arrow_666_14@3x.png';
import icArrow1 from 'Assets/img/sidebar/ic_arrow_blue_14.png';
import icArrow2 from 'Assets/img/sidebar/ic_arrow_blue_14@2x.png';
import icArrow3 from 'Assets/img/sidebar/ic_arrow_blue_14@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';

const icArrowEmpty = getImageSet([icArrowEmpty1, icArrowEmpty2, icArrowEmpty3]);
const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);

const YearDropdown = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { formatMessage } = useIntl();

  useEffect(() => {
    const handleClickOutside = event => {
      if (!isOpen) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const handleChange = value => {
    onChange(value);
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} className="field-sidebar-year-dropdown cursor-pointer no-drag">
      <div className={`field-sidebar-year-dropdown-selected ${value ? 'selected' : ''}`} onClick={() => setIsOpen(prev => !prev)}>
        <div>{value ? `${value}${formatMessage({ id: 'common.year' })}` : formatMessage({ id: 'sidebar.field.year' })}</div>
        <img {...(value ? icArrow : icArrowEmpty)} alt="arrow" />
      </div>
      {isOpen && (
        <div className="field-sidebar-year-dropdown-option" data-field-toggle="true">
          <div className="field-sidebar-year-dropdown-option-item" onClick={() => handleChange(null)}>
            <div style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>{formatMessage({ id: 'sidebar.field.year' })}</div>
            <img {...icArrowEmpty} alt="arrow" style={{ transform: 'rotate(180deg)' }} />
          </div>
          {options.map(option => (
            <div key={option} className="field-sidebar-year-dropdown-option-item" onClick={() => handleChange(option)}>
              {`${option}${formatMessage({ id: 'common.year' })}`}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default YearDropdown;
